(function(){
    var KRP0010_PRINT = '<html lang="ko">' +
        '<head>' +
            '<meta charset="UTF-8">' +
            '<meta http-equiv="X-UA-TextLayoutMetrics" content="gdi" />' +
            '<meta name="viewport" content="width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no">' +
            '<title>제품 상세 스펙</title>' +
            '<link rel="shortcut icon" href="/lg5-common/images/favicon.ico">' +
            '<link rel="stylesheet" href="/lg5-common/css/reset.min.css" />' +
            '<link rel="stylesheet" href="/lg5-common/css/app.min.css" />' +
            '<link type="text/css" rel="stylesheet" href="/lg5-common/css/components/KRP0010.min.css" />' +
            '<script src="/lg5-common/js/libs/jquery-2.2.4.min.js"></script>' +
            // '<script src="/lg5-common/js/libs/jquery.transit.min.js"></script>' +
            // '<script src="/lg5-common/js/libs/jquery.event.move.min.js"></script>' +
            // '<script src="/lg5-common/js/libs/jquery.twentytwenty.min.js"></script>' +
            // '<script src="/lg5-common/js/libs/jquery.mCustomScrollbar.min.js"></script>' +
            // '<script src="/lg5-common/js/vcui.min.js"></script>' +
            // '<script src="/lg5-common/js/vcui.common-ui.min.js"></script>' +
            // '<script src="/lg5-common/js/lg.common.min.js"></script>' +
            // '<script src="/lg5-common/js/components/KRP0010.min.js"></script>' +
        '</head>' +
        '<body><div class="wrap"><div class="container"><div id="pdp_spec" class="component-wrap">' +
            '<section class="component KRP0010"><div class="component-inner"><div><div class="prod-spec-wrap">' +
                '{{#raw html}}' +
            '</div></div></div></section>' +
        '</div></div></div></body>' +
    '</html>';

    /* BTOCSITE-33498 스펙용어사전  */
    var specImgTemplate = '<div class="item item-box ui_carousel_slide">' +
    							'<div class="visual-wrap">' +
	    							'<div class="visual-area image">'+
										'<img src="{{_imgCont}}" alt="{{_imgAltText}}">'+
									'</div></div></div>';

    function funcReady() {
        var $KRP0010 = $('.KRP0010');

        $KRP0010.find('.btn_collapse_more a').attr('role', 'button');
        $KRP0010.find('.btn_collapse_more a').eq(0).attr('title', '제품스펙 상세정보 펼치기');
        $KRP0010.find('.btn_collapse_more a').eq(1).attr('title', '제품스펙 상세정보 접기');
        $KRP0010.on('click', '.btn_collapse_more a', function(e){
            e.preventDefault();

            var idx = $(this).index() ? 0 : 1;
            var wrap = $(this).closest('.prod-spec-wrap');
            var spec = wrap.find('.prod-spec-detail');
            if(idx){
                spec.slideDown();

                var offsetop = $(this).parent().offset().top;
                $('html, body').stop().animate({scrollTop:offsetop}, 300);
            } else{
                spec.slideUp();
            }
            $(this).parent().children().css('display', 'none').eq(idx).css('display', 'block').focus();
        });

        $KRP0010.on('click', 'div.prod-print button', function(e){
            e.preventDefault();
            var $parent = $(this).parents('div.prod-spec-wrap');
            var html = $parent.html();
            var setting = "width=640, height=800, all=no";
            var objWin = window.open('', 'print',setting);
            objWin.document.write(vcui.template(KRP0010_PRINT, {"html":html}));
            objWin.focus();
            objWin.document.close();
            objWin.onload=function() {
                $(objWin.document).find('div.prod-spec-detail').show();
                objWin.onafterprint = function () { objWin.close(); }; // BTOCSITE-33010
                objWin.print();
            }
        });

         /* BTOCSITE-33498 스펙용어사전  */
         $KRP0010.on('click', '.spec-info-list button', function(e){
        	e.preventDefault();

        	var $specDictionaryPopup = $("#specDictionaryPopup");
        	var $popTextDiv = $specDictionaryPopup.find(".textDiv");
        	var $popVideoDiv = $specDictionaryPopup.find(".videoDiv");
        	var $popImgDiv = $specDictionaryPopup.find(".imgDiv");
        	var specDescription = $(this).data("specDescription");
        	var specType = $(this).data("specType");
        	var specContents = $(this).data("specContents");
        	var specImgAltText = $(this).data("imgAltText");
        	var specImgPath = $(this).data("imgPath");
        	
        	//개행문자가 \n으로 넘어와서 개행처리 
        	specDescription = vcui.string.escapeHTML(specDescription);
        	specDescription = specDescription.replace(/(?:\r\n|\r|\n)/g, "<br/>");
        	
        	//스펙명
        	$specDictionaryPopup.find(".tit span").text("");
        	$specDictionaryPopup.find(".tit span").text($(this).text());
            
			//BTOCSITE-81509 동영상 초기화 감추기
			$specDictionaryPopup.find('.visual-area').closest('.component').hide();

        	if (specType == "I") { //Image
        		$popTextDiv.css("display","none");
        		$popVideoDiv.css("display","none");
        		$popImgDiv.css("display","");
        		$popImgDiv.find(".m-content p").html(specDescription);
        		//이미지는 여러개로, 구분자로 split하여 만들어둔 template에 데이터 바인딩 하여 추가해준다.
        		var imgConts = specContents.split("^||^");
        		var imgAltTexts = specImgAltText.split("^||^");
        		var imgPaths = specImgPath.split("^||^");
        		var imgTotal = imgConts.length;
        		var tempStr = '<div class="ui_carousel_list"><div class="items-group component-inner-box ui_carousel_slider"><div class="items ui_carousel_track">';
        		for (var i = 0; i < imgConts.length; i++) {
        			var item = {};
        			item._imgCont = imgConts[i];
        			item._imgAltText = imgAltTexts[i];
        			tempStr += vcui.template(specImgTemplate, item);
        		}
        		tempStr += '</div>';
        		if (imgTotal > 1) { // 2개 이상일 경우만 컨트롤러 노출 
        			tempStr += '<div class="slide-controls">' +
	        			'<button type="button" class="btn-arrow prev ui_carousel_prev"><span class="blind">이전</span></button>'+
	        			'<div class="slide-number"><strong class="current">1</strong><span class="total">' + imgTotal + '</span></div>'+
	        			'<button type="button" class="btn-arrow next ui_carousel_next"><span class="blind">다음</span></button>'+
        			'</div>';
        		}
                tempStr += '</div></div>';
        		$popImgDiv.find(".color-slider-wrap").empty();
        		$popImgDiv.find(".color-slider-wrap").append(tempStr);
        		
        		$('.color-slider-wrap').buildCommonUI();
                vcui.require(['ui/carousel'], function () {
                	$popImgDiv.find('.ui_carousel_slider').vcCarousel({
                        infinite: true,
                        swipeToSlide: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        prevArrow:'.btn-arrow.prev',
                        nextArrow:'.btn-arrow.next',
                        adaptiveHeight:false,
                        lazyLoad:'anticipated', //수정 jsw
                        cssEase: 'cubic-bezier(0.33, 1, 0.68, 1)',
                        touchThreshold: 100,
                        speed: 150
                    });
                });
              //이미지가 1개일때는 <,> 컨트롤러 보이지 않게 한다.
        		if (imgTotal > 1) {
        			$popImgDiv.find('.ui_carousel_slider').on('carouselafterchange', function(e,target,index){
        				$popImgDiv.find('.slide-number').children('.current').text(index + 1);
        			});
        		}
        	} else if (specType == "V") {//Video
        		$popTextDiv.css("display","none");
        		$popVideoDiv.css("display","");
        		$popImgDiv.css("display","none");
        		$specDictionaryPopup.find(".videoDiv .m-content p").html(specDescription);
        		//확장자 체크 (동영상, 유튜브 구분) mp4 -> video / youtube -> iframe
				if (specContents.indexOf(".mp4") > 0) {	//video
					$("#specVideoPlayer").attr("src","");
					$("#specVideoPlayer").css("display","none");
					$popVideoDiv.find(".mp4-wrap").css("display","");
					$popVideoDiv.find("video").attr("src", specContents);
				} else {//youtube
					$popVideoDiv.find("video").attr("src", "");
					$popVideoDiv.find(".mp4-wrap").css("display","none");
					//유튜브 임베드 링크가 아닐경우
					if (specContents.indexOf("/embed/") < 0) { 
						specContents = "https://www.youtube.com/embed/" + specContents.substring(specContents.lastIndexOf("/"));
					}
					$("#specVideoPlayer").css("display","");
					$("#specVideoPlayer").attr("src", specContents + "?autoplay=1&mute=1");
				}

				//BTOCSITE-81509
				$specDictionaryPopup.find('.visual-area').hide();
				$specDictionaryPopup.find('.visual-area').closest('.component').show();
        		//확장자 체크 (동영상, 유튜브 구분) mp4 -> video / youtube -> iframe
				if (specContents.indexOf(".mp4") > 0) {	//video
					if(specImgAltText.trim().length == 0){ //설명자막이 존재하지 않을 경우
						$specDictionaryPopup.find('.animation-box .video-caption-wrap').hide();
                        $specDictionaryPopup.find('.animation-box .video-cap-section').hide();
					}
					$specDictionaryPopup.find('.animation-box .video-cap-section .rectangle').val(specImgAltText)
					$specDictionaryPopup.find('.animation-box').show();
				} else {//youtube
					if(specImgAltText.trim().length == 0){ //설명자막이 존재하지 않을 경우
						$specDictionaryPopup.find('.youtube-box .video-caption-wrap').hide();
                        $specDictionaryPopup.find('.youtube-box .video-cap-section').hide();
					}
					$specDictionaryPopup.find('.youtube-box .video-cap-section .rectangle').val(specImgAltText)
					$specDictionaryPopup.find('.youtube-box').show();
				}
        	} else if (specType == "H") {//Html
        		$popTextDiv.css("display","");
        		$popVideoDiv.css("display","none");
        		$popImgDiv.css("display","none");
        		$popTextDiv.find("p").html(specContents);
        	} else { //Text
        		$popTextDiv.css("display","");
        		$popVideoDiv.css("display","none");
        		$popImgDiv.css("display","none");
        		$popTextDiv.find("p").html(specDescription);
        	}
        	$('#specDictionaryPopup').vcModal();
        });

        $(document).on('click', '.ui_modal_dim', function(e) {
            $('.spec-pop').find('.ui_modal_close').trigger('click');
        });

        $('.btn-quality').on('click', function() {
            var specVideo = $('.spec-video').find('video').get(0);
            var btnPlay = $('.spec-video').find('.btn-play');
            var isActive = 'is-active';
            specVideo.paused ? btnPlay.removeClass(isActive) : btnPlay.addClass(isActive);
        });

        specCarousel('.btn-wide-color', '.color-slider-wrap');
        specCarousel('.btn-brightness', '.brightness-slider-wrap');
        
        //BTOCSITE-81509 웹접근성
        $('.popup-wrap').on('click','.video-caption-wrap .btn-video, .video-cap-section .btn-close',function(e){
            var $cap = $(this).closest('.visual-area').find('.video-cap-section');
            $cap.toggle();
            if($(this).closest('.visual-area').find('.youtube').length == 1){
				var $btn = $(this).closest('.visual-area').find('.video-caption-wrap')
				if($cap.css('display') == 'none'){
					$btn.find('.btn-video').removeClass('on')
					$btn.find('.btn-video').text('동영상 설명보기')
				}else{
					$btn.find('.btn-video').addClass('on')
					$btn.find('.btn-video').text('동영상 설명닫기')
				}	
            }
        });
    }

    function specCarousel(btn, sliderWrap) {
        var btnSlider = $(btn);

        btnSlider.on('click', function() {
            $(sliderWrap).buildCommonUI();

            vcui.require(['ui/carousel'], function () {
                $(sliderWrap).find('.ui_carousel_slider').vcCarousel({
                    infinite: true,
                    swipeToSlide: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow:'.btn-arrow.prev',
                    nextArrow:'.btn-arrow.next',
                    adaptiveHeight:false,
                    lazyLoad:'anticipated', //수정 jsw
                    cssEase: 'cubic-bezier(0.33, 1, 0.68, 1)',
                    touchThreshold: 100,
                    speed: 150
                });
            });

            setTimeout(function() {
                var specCarouselSlider = $(sliderWrap).find('.ui_carousel_slider');
                var specCarouselSlideLast = parseInt(specCarouselSlider.find('.ui_carousel_slide:last').attr('data-ui_carousel_index'));
                if(specCarouselSlideLast == 0) {
                    specCarouselSlider.find('.slide-controls').hide();
                } else {
                    specCarouselSlider.find('.slide-controls').children('.slide-number').children('span').text(specCarouselSlideLast);
                }
            },10);

            $(sliderWrap).find('.ui_carousel_slider').on('carouselafterchange', function(e,target,index){
                $(sliderWrap).find('.slide-number').children('.current').text(index + 1);
            });
        });
    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'SPEC', name: 'KRP0010', isFirstLoad: false, fn: function () {
                if(!document.querySelector('.KRP0010')) return false;
                funcReady();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(document).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        if(!document.querySelector('.KRP0010')) return false;
        funcReady();
    });
})();